import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommunityList } from "../../../../redux/slices/PostFormSlice";
import CommunityCards from "./CommunityCards";
import "./CommunityStyles.css"; // Import external CSS

const CommunityNews = () => {
  const { communityList } = useSelector((state) => state.postForm);
  const myPosts = communityList?.filter(
    (post) => post.postType === "localNewspapers" && post.communityStatus === 1
  );

  if (!myPosts || myPosts.length === 0) {
    return;
  }

  return (
    <div className="post-container">
      <h5>
        <em> Local Newspapers</em>
      </h5>

      <div className="grid-container">
        {myPosts.map((post) => (
          <Box key={post.id} className="grid-item">
            <CommunityCards post={post} />
          </Box>
        ))}
      </div>
    </div>
  );
};

export default CommunityNews;
